import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { Window, CreateWindowDto } from 'types';

export const createWindow = ({
  data,
}: {
  data: CreateWindowDto;
}): Promise<Window> => {
  return axios.post('/api/windows', data);
};

type UseCreateWindowOptions = {
  wallId: number;
  config?: MutationConfig<typeof createWindow>;
};

export const useCreateWindow = ({ wallId, config }: UseCreateWindowOptions) => {
  return useMutation({
    onMutate: async (newWindow) => {
      await queryClient.cancelQueries(['windows', wallId]);

      const previousWindows = queryClient.getQueryData<Window[]>([
        'windows',
        wallId,
      ]);

      queryClient.setQueryData(
        ['windows', wallId],
        [...(previousWindows || []), newWindow.data]
      );

      return { previousWindows };
    },
    onError: (_, __, context: any) => {
      if (context?.previousWindows) {
        queryClient.setQueryData(['windows', wallId], context.previousWindows);
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['windows', wallId]);
      queryClient.invalidateQueries(['wall', wallId]);
    },
    ...config,
    mutationFn: createWindow,
  });
};
